import { FC } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Dashboard } from '@bemap/ui';
import { PARTNER_ROUTES } from '@bemap/utils';
import AnalystsPage from '../pages/analysts/analysts-page';
import ViewAnalystPage from '../pages/analysts/view-analyst';
import PeoplePage from '../pages/people/people-page';
import CertificatesList from '../pages/certificates/list-certificates';
import CourseCertificatesPage from '../pages/certificates/course-certificates';
import { ISession } from '@bemap/utils';
import IntegrationsManagement from '../pages/integrations/integrations-page';
import PartnerDashboard from '@/pages/dashboards/partner';
import TeamSettings from '../pages/team-settings';
import ProfileEditPage from '../pages/profile-edit';
import StudentDashboard from '@/pages/dashboards/student';
import CourseEnrollment from '@/pages/CourseEnrollment';
import Courses from '@/pages/Courses';
import University from '@/pages/University';
import AssessmentResultsPage from '@/pages/assessments/assessment-results-page';

const appVersion = __APP_VERSION__
interface ProtectedLayoutProps {
  user: ISession | null;
}

const PartnerRoutes: FC<ProtectedLayoutProps> = ({ user }) => {
  return (
    <Dashboard user={user} appVersion={appVersion}>
      <Routes>
        <Route path="/" element={<Navigate to={PARTNER_ROUTES.DASHBOARD} replace />} />
        <Route path={PARTNER_ROUTES.DASHBOARD} element={<PartnerDashboard />} />
        <Route path={PARTNER_ROUTES.ANALYSTS} element={<AnalystsPage />} />
        <Route path={PARTNER_ROUTES.ANALYSTS_VIEW} element={<ViewAnalystPage />} />
        <Route path={PARTNER_ROUTES.ASSESSMENTS_VIEW} element={<AssessmentResultsPage />} />
        <Route path={PARTNER_ROUTES.PEOPLE} element={<PeoplePage />} />
        <Route path={PARTNER_ROUTES.CERTIFICATES} element={<CertificatesList />} />
        <Route path={PARTNER_ROUTES.INTEGRATIONS} element={<IntegrationsManagement />} />
        <Route path={PARTNER_ROUTES.TEAM} element={<TeamSettings />} />
        <Route path={PARTNER_ROUTES.PROFILE} element={<ProfileEditPage />} />
        <Route path={PARTNER_ROUTES.UNIVERSITY} element={<StudentDashboard />} />
        <Route path={PARTNER_ROUTES.UNIVERSITY_CERTIFICATES} element={<CourseCertificatesPage />} />
        <Route path={PARTNER_ROUTES.UNIVERSITY_COURSES} element={<Courses />} />
        <Route path={PARTNER_ROUTES.UNIVERSITY_COURSES_VIEW} element={<University />} />
        <Route path={PARTNER_ROUTES.UNIVERSITY_COURSES_CONTENT} element={<University />} />
        <Route path={PARTNER_ROUTES.UNIVERSITY_COURSES_ENROLL} element={<CourseEnrollment />} />
        <Route path="*" element={<Navigate to={PARTNER_ROUTES.DASHBOARD} replace />} />
      </Routes>
    </Dashboard>
  );
};

export default PartnerRoutes; 